import React from "react";
import { useNavigate } from "react-router-dom";
import { supabase } from "@/lib/supabase";

/**
 * Shown when admin has blocked this caterer account.
 * Caterer cannot perform actions; they see this screen instead of the app.
 */
export default function BlockedScreen() {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await supabase.auth.signOut();
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6">
      <div className="max-w-md w-full rounded-xl border border-border bg-card p-8 shadow-lg text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-rose-100 text-rose-600 mb-6">
          <svg className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M18.364 18.364A9 9 0 005.636 5.636m12.728 12.728A9 9 0 015.636 5.636m12.728 12.728L5.636 5.636" />
          </svg>
        </div>
        <h1 className="text-xl font-bold text-foreground mb-2">Account blocked</h1>
        <p className="text-muted-foreground text-sm mb-6">
          Your caterer account has been blocked by Mrs Cater. You cannot access the dashboard, accept orders, or perform any actions until the block is lifted.
        </p>
        <p className="text-xs text-muted-foreground mb-6">
          If you believe this is an error, please contact support with your business details.
        </p>
        <button
          type="button"
          onClick={handleSignOut}
          className="inline-flex items-center justify-center rounded-md border border-border bg-background px-4 py-2 text-sm font-medium text-foreground hover:bg-muted"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
